// Lib imports
import Vue from 'vue'
let vue = new Vue()
import forEach from 'lodash.foreach'
export const errorHandler = (status, message = 'Unknown Error', errors = false) => {
    if (status !== 200) {
        if (message === 'canceled') return true
        if (errors) {
            loopErrors(errors)
        } else {
            vue.$noty.error(message)
        }
        return true
    }
    return false
}


function loopErrors(errors, internal_key = null) {
    forEach(errors, (value, key) => {
        let field = internal_key? `${internal_key}.${key}`: key
        console.error(`value: `, value,`key: ${key}`, `Field: ${field}`)
        if (typeof value === 'object' ) {
            return loopErrors(value, field)
        }
        vue.$noty.error(`${field} - ${value}`)
    })
}

Vue.prototype.$error = errorHandler
